import {useEffect, useRef, useState} from "react";
import {Calendar} from "react-date-range";
import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {scheduleState, setDateToWorkAction,} from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import {convertYYYYMMDDddFormat, dateFormat,} from "../../utils/date/date-format";
import CalendarLineIcon from "../icons/CalendarLineIcon/CalendarLineIcon";
import {useClickOutside} from "../../utils/click/handle-click";

interface Props {
}

export const ScheduleCreateCalendar: React.FC<Props> = ({}) => {
    const dispatch = useAppDispatch();

    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const {dateToWork, updateSchedule} = useAppSelector(scheduleState);

    const updateDateToWork = (dateToWork: string) => {
        dispatch(
            setDateToWorkAction({
                dateToWork,
            })
        );
    };

    const handleClickBox = () => {
        setOpen(!open);
    };

    useClickOutside(ref, () => setOpen(false));

    useEffect(() => {
        if (updateSchedule) {
            updateDateToWork(updateSchedule.dateToWork);
        } else {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);
            updateDateToWork(dateFormat(tomorrow));
        }
    }, [updateSchedule]);

    return (
        <Container ref={ref}>
            <ScheduleCreateCalendarContainer onClick={handleClickBox}>
                <IconContainer>
                    <CalendarLineIcon
                        width="1.125rem"
                        height="1.125rem"
                        fill={theme.palette.primitives.yellow400}
                    />
                </IconContainer>
                <DateContainer>
                    배송일: {convertYYYYMMDDddFormat(dateToWork)}
                </DateContainer>
            </ScheduleCreateCalendarContainer>
            {open && (
                <CalendarContainer>
                    <Calendar
                        editableDateInputs={true}
                        date={new Date(dateToWork)}
                        onChange={(item) => updateDateToWork(dateFormat(item))}
                        color={theme.palette.primitives.yellow400}
                    />
                </CalendarContainer>
            )}
        </Container>
    );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 999999;
  cursor: pointer;

  &:hover {
    background-color: ${theme.palette.primitives.gray50};
  }
`;

const ScheduleCreateCalendarContainer = styled.div`
  width: 212px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  border: 1px solid ${theme.palette.primitives.gray300};
`;

const IconContainer = styled.div`
  margin: 0.2rem 4px 0 0;
`;

const DateContainer = styled.div`
  font-weight: 500;
  font-size: 0.938rem;
  line-height: 1.125rem;
  letter-spacing: 0.04rem;
  color: ${theme.palette.primitives.gray900};
`;

const CalendarContainer = styled.div`
  position: absolute;
  margin-top: 2.5rem;

  .rdrDayToday .rdrDayNumber span:after {
    background-color: ${theme.palette.primitives.yellow400};
  }

  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: black;
  }

  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);

  z-index: 99999;
`;
